"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function loadScript(url, callback) {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  head.appendChild(script);
  if (callback) {
    script.onload = callback;
  }
  script.src = url;
}
var _default = loadScript;
exports.default = _default;